import '../IconText/IconText.css';
import './VoteSplit.css';

type Props = {
    accepted: number;
    rejected: number;
    title?: string;
};

const VoteSplit = ({ accepted, rejected, title }: Props) => (
    <div className='vote-split' title={title}>
        <span className='icon-text success'>
            <span className='material-symbols-rounded'>check_box</span>
            {accepted}
        </span>
        <span className='icon-text error'>
            <span className='material-symbols-rounded'>disabled_by_default</span>
            {rejected}
        </span>
    </div>
);

export default VoteSplit;
